import { render, staticRenderFns } from "./ExcelToJSON.vue?vue&type=template&id=bbc92340&scoped=true"
import script from "./ExcelToJSON.vue?vue&type=script&lang=js"
export * from "./ExcelToJSON.vue?vue&type=script&lang=js"
import style0 from "./ExcelToJSON.vue?vue&type=style&index=0&id=bbc92340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc92340",
  null
  
)

export default component.exports